import NotFound from "../pages/NotFound";
import MainPage from "../pages/main/MainPage";

export const privateRoutes = [
  { path: "/payment-method/:lng/:token?", component: MainPage, exact: true },
  { path: "/not-found", component: NotFound, exact: true }
];
